<span class="grid-cell-text__content" [title]="tooltip()">{{ displayText() }}</span>
@if (hasLink()) {
    <a
        class="dx-link cn-icon-ico-link dx-link-icon grid-cell-text__link"
        [routerLink]="link()!.routerLink"
        [queryParams]="link()!.queryParams ?? null"
        [attr.title]="'details' | transloco"
        [attr.aria-label]="'details' | transloco"
        (click)="onLinkClick($event)"
    ></a>
}
